import { Capacitor } from "@capacitor/core";

/** Vrai si l'app tourne dans un conteneur natif (iOS/Android via Capacitor) */
export const isNative = Capacitor.isNativePlatform();

/** Plateforme courante : "ios" | "android" | "web" */
export const platform = Capacitor.getPlatform() as "ios" | "android" | "web";

export const isIOS = platform === "ios";
export const isAndroid = platform === "android";

// Marquer le HTML pour le CSS conditionnel (anti-bounce iOS, etc.)
if (isNative) {
  document.documentElement.classList.add("native-app");
}
